<template>
  <div v-on:mouseenter="()=>{hoverOnMessage(true)}"
       v-on:mouseleave="()=>{hoverOnMessage(false)}">
    <s-card :border="false" :padding="true" class="flex-grow container pr-0">
      <div class="relative">
        <message :display-name="fullName(thread)"
                 :message-body="thread.messageBody"
                 :message-time="thread.messageTime "
                 :attachments="thread.attachments"
                 @open-attachment="openAttachment"

        />
        <div class="absolute flex reply-button" v-if="showReplyButton">
          <s-button icon="emoji.png" title=""
                    :rounded-square="true"
                    :right-borders-square="true"
                    :outline="false"
          />
          <s-button icon="reply.png" title=""
                    :rounded-square="true"
                    :left-borders-square="true"
                    :outline="false"
                    @clicked-item="onReplyClicked"
          />
        </div>
      </div>
      <div class="mt-24 three-column-grid" v-show="thread.replies.length>0 || replyClicked">
        <div></div>
        <SAccordion
            ref="replyAccordion"
            :expandIcon="'arrows'"
            :border="false"
            :title="thread.replies.length===1 ? '1 Reply' : (thread.replies.length + ' Replies')"
            :padding="'40'"
            :shadow="true"
            :always-shadow="true"
            :open="replyClicked"
        >
          <SCardSection :padding="false" >
            <div v-for="(reply,index) in thread.replies" :key="index" class="p-16">
              <message :display-name="fullName(reply)" :message-body="reply.messageBody" :message-time="reply.replyTime | dateTimeByTimeZone(timeZoneRegion)"/>

            </div>
            <message-box ref="messageBox" :wall-users="wallUsers" v-model="replyMessage" @send-message="sendReply"/>
          </SCardSection>

        </SAccordion>
      </div>
    </s-card>
  </div>
</template>

<script>
import SButton from "./SButton";
import SCard from "./SCard";
import Message from "./Message";
import SAccordion from "./SAccordion";
import SCardSection from "./SCardSection";
import MessageBox from "./MessageBox";
export default {
name: "MessageThread",
  components:{
    MessageBox,
    SButton,
    SCard,
    Message,
    SAccordion,
    SCardSection,
  },
  props: {
    value: {},
    thread: {required: true},
    timeZoneRegion: {},
    wallUsers: {},
  },
  data: function (){
    return {
      inputFocused: false,
      showReplyButton: false,
      replyClicked:false,
      replyMessage:'',
    }
  },
  methods: {
    openAttachment(attachment){
      this.$emit('open-attachment',attachment);
    },
    fullName: function (data) {
      if (data) {
        return data.firstName + (data.lastName ? (' ' + data.lastName) : '');
      }
      return '';
    },
    handleInput: function (event) {
      this.$emit("input", event.target.value);
    },
    onInputFocus(){
      this.inputFocused = true;
      this.$emit('focus-change',true);
    },
    onInputBlur(){
      this.inputFocused = false;
      this.$emit('focus-change',false);
    },
    sendMessage(){
      this.$emit('send-message',this.value);
    },
    hoverOnMessage(hoverStatus){
      this.showReplyButton = hoverStatus;
    },
    onReplyClicked(){
      this.replyClicked = true;
      this.$refs.replyAccordion.openAccordion()
      //transfer focus to there
      if(this.$refs.replyMessageBox){
        this.$refs.messageBox.setFocusToMessageField();
      }
      else {
        //set focus using ref with using time out because it takes a bit of mili seconds to set reference after reply accordion is shown
        setTimeout(()=>{
          console.log(this.$refs.replyMessageBox);
          this.$refs.messageBox.setFocusToMessageField();
        }, 500);
      }

    },

    clearMessageBox(replyObject){
      this.$refs.messageBox.clearMessageBox();
      this.thread.replies.push(replyObject);
    },

    sendReply(data){
      this.$emit('send-message',data);
    }
  }
}
</script>

<style scoped lang="scss">


.flex-grow{
  flex-grow: 1;
  align-self: stretch;
}

.message-box {
  height: 57px !important;
  display: flex;
}

.container {
  height: 100%;
  //width: 100%;
  padding-left:0;
  padding-right:0;
}

.flex {
  display: flex;
  flex: 1;
}
.flex-column {
  flex-direction: column;
}
.flex-row {
  flex-direction: row;
}

.justify-center {
  justify-content: center;
}
.content-stretch {
  align-content: stretch;
}
.content-center {
  align-content: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.items-center {
  align-items: center;
}
.text-bold{
  font-weight: bold;
}

.width-100{
  width: 100%;
}
.height-100{
  height: 100%;
}
.font-14{
  font-size: 16px;
}

.no-resize {
  resize: none;
}

.pb-16 {
  padding-bottom: 16px;
}
.pb-24 {
  padding-bottom: 24px;
}
.pr-12 {
  padding-right:12px;
}
.p-8{
  padding: 8px;
}
.pr-0{
  padding-right:0;
}

.p-12 {
  padding: 18px;
}
.pl-64{
  padding-left: 64px;
}
.ml-32 {
  margin-left: 32px;
}
.ml-92 {
  margin-left: 92px;
}
.mr-16 {
  margin-right: 16px;
}

.p-16 {
  padding: 16px;
}

.mt-16 {
  margin-top:16px
}
.p-0{
  padding: 0;
}

.pl-64{
  padding-left: 64px;
}

.three-column-grid {
  display: grid;
  grid-template-columns: 0.5fr 9fr 0.2fr;
  grid-column-gap: 30px;
  grid-row-gap: 20px;
}

.reply-button {
  top:16px;
  right:4%;
}



</style>